import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [

      { path: '/', component: () => import('@/layout'),
        children: [
          { path: '/', component: () => import('@/components/home') },
          { path: '/inicio', component: () => import('@/components/inicio') },
          { path: '/diario', component: () => import('@/components/diario') },
          { path: '/ocorrencias', component: () => import('@/components/ocorrencias') },
          { path: '/materiais', component: () => import('@/components/materiais') },
          { path: '/calendario', component: () => import('@/components/calendario') },
          { path: '/cardapio', component: () => import('@/components/cardapio') },
          { path: '/mensagens', component: () => import('@/components/mensagens') }
        ],
      }
  ]
})

export default router
